import React from 'react';
import cn from 'classnames';
import moment from 'moment-timezone';
import { useTheme } from 'providers/Theme.provider';

import Toggler from 'components/Toggler.component';

import CN from './TimeItem.module.scss';

const TimeItem = ({ itemStylistId = null, optionsCount, ItemTime, timezone, onCheckboxClick, checked }) => {
  const { isDarkMode, isNeutralMode } = useTheme();

  const handleCheckboxClick = () => {
    if (itemStylistId) {
      onCheckboxClick(ItemTime, itemStylistId);
    } else {
      onCheckboxClick(ItemTime);
    }
  };

  const getOptionText = () => {
    // when a specific stylist is selected and there is only 1 option -> we don't show anything
    if (itemStylistId && optionsCount === 1) return '';

    // when it's "I don't mind" and there is more than 1 option -> "n options"
    if (!itemStylistId && optionsCount > 1) {
      return `${optionsCount} options`;
    }

    return '';
  };

  const componentClasses = cn({
    [CN.component]: true,
    [CN.selected]: checked,
    [CN.dark]: isDarkMode,
    [CN.neutral]: isNeutralMode,
  });

  const time = moment(ItemTime).tz(timezone).format('hh:mm A');
  const text = getOptionText();

  return (
    <div className={componentClasses} role="button" tabIndex={0} onClick={handleCheckboxClick}>
      <div className={CN.flex}>
        <span className={CN.title}>{time}</span>
        {text && <span className={CN.subTitle}>{text}</span>}
      </div>

      <Toggler selected={checked} tag="TimeItem__toggler" />
    </div>
  );
};

export default TimeItem;
